import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Price from 'Components/Utility/Price/Price';
import pricing from 'Components/StaticSearch/games-under-pricing';
import store from 'Redux/store';

const TrackedLink = ({ to, children, ...props }) => {
  const onClick = () => {
    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'BrowseFanatical', value: to },
    });
  };

  return (
    <Link to={to} onClick={onClick} {...props}>
      {children}
    </Link>
  );
};

TrackedLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default function QuickLinks() {
  return (
    <section className="quick-links container">
      <div className="section-heading-container">
        <h2>
          <FormattedMessage id="home.quick.browse" defaultMessage="Browse Fanatical" />
        </h2>
      </div>
      <div className="quicklinks-container">
        <div className="quick-link">
          <TrackedLink to="/bundle/games">
            <FormattedMessage id="home.quick.bundles" defaultMessage="Game Bundles" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/on-sale">
            <FormattedMessage id="home.quick.onsale" defaultMessage="On Sale Now" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/latest-deals">
            <FormattedMessage id="home.quick.latest" defaultMessage="Latest Deals" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/top-sellers">
            <FormattedMessage id="home.quick.topsellers" defaultMessage="Top Sellers" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/games-under/5">
            <FormattedMessage
              id="home.quick.under"
              defaultMessage="Games Under {price}"
              tagName="span"
              values={{
                price: <Price
                  hideDecimals
                  price={pricing['5'].max}
                />,
              }}
            />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/vr-games">
            <FormattedMessage id="home.quick.vrgames" defaultMessage="VR Games" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/categories/rpg">
            <FormattedMessage id="home.quick.rpgames" defaultMessage="Role Playing Games" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/ending-soon">
            <FormattedMessage id="home.quick.lastchance" defaultMessage="Last Chance to Save" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/categories/anime">
            <FormattedMessage id="home.quick.animegames" defaultMessage="Anime Games" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/bundle/books">
            <FormattedMessage id="home.quick.books" defaultMessage="Books" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/categories/party">
            <FormattedMessage id="home.quick.fpsgames" defaultMessage="Party Games" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/trending-deals">
            <FormattedMessage id="home.quick.trendingdeals" defaultMessage="Trending Deals" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/new-releases">
            <FormattedMessage id="home.quick.newreleases" defaultMessage="New Releases" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/best-games-of-2024">
            <FormattedMessage id="home.quick.bestgamesof2024" defaultMessage="Best Games of 2024" />
          </TrackedLink>
        </div>
        <div className="quick-link">
          <TrackedLink to="/search">
            <FormattedMessage id="home.quick.browseall" defaultMessage="Browse All" />
          </TrackedLink>
        </div>
      </div>
    </section>
  );
}
